<template>   
        <router-view></router-view>    
</template>

<script>
    // Le script
    export default {
        name : "app_router",
    }
</script>